import { h } from "preact";
import IconProps from "./IconProps";

const DEFAULT_WIDTH = 31;
const DEFAULT_HEIGHT = 36;

function IconMuted({ color, width, height, class: cssClass }: IconProps) {
    return (
        <svg class={cssClass} width={width} height={height} viewBox="0 0 31 36">
            <path fill={color} d="M35.997 27.472h-.536l-1.177-10.015-16.284 16 17.98-.034c1.66 0 3.02-1.335 3.02-2.985.007-1.632-1.341-2.966-3.003-2.966M28.583 36c.507-.001.918.379.917.854-.006 2.836-2.474 5.14-5.511 5.146-3.038.006-5.495-2.289-5.489-5.124.001-.474.42-.857.92-.858zm-4.85-30c3.74-.008 7.202 2.298 8.884 5.566l3.722-3.722c.499-.498 1.305-.498 1.803 0 .498.497.498 1.304 0 1.803L10.176 37.613c-.249.25-.575.374-.901.374-.327 0-.652-.125-.901-.374-.499-.497-.499-1.305 0-1.803l3.06-3.06c-1.439-.201-2.552-1.433-2.552-2.925.01-1.648 1.334-2.983 2.966-2.983h.528l1.419-11.96C14.382 9.988 18.827 6.01 23.732 6z" transform="translate(-8 -6)"/>
        </svg>
    );
}

IconMuted.defaultProps = {
    color: "var(--gandalf)",
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT
};

export default IconMuted;
